import i18next from 'i18next'
import React, { useEffect, useState } from 'react'
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const HtmlContentMaster = ({ keyName }) => {
  const privacyLanguage = useSelector((state) => state.language.langData);
  const { t, i18n } = useTranslation();
  useEffect(() => {
    if (privacyLanguage && privacyLanguage !== i18n.language) {
      i18n.changeLanguage(privacyLanguage);
    }
  }, [privacyLanguage, i18n]);

  const [headerTitle] = useState({
    // tos: (
    //   <h3>Terms of Service</h3>
    // ),
    // privacypolicy: (
    //   <h3>Privacy Policy</h3>
    // )
  })
  const [htmlContent] = useState({
    tos: (
      <div className="container privacy-main-div">
        <h1 className="privacy-title" data-i18n="terms.title">{i18next.t("Terms of Service")}</h1>
        <div>
            <div>
            <h3 data-i18n="terms.effectiveDate">{i18next.t("Effective Date: January 1, 2025")}</h3>
            <p data-i18n="terms.intro">{i18next.t("Welcome to Aloxa.ai, a digital platform operated by Centa Biotech SL ('Centa Biotech', 'we', 'us', or 'our'). These Terms and Conditions ('Terms') govern your access to and use of our services, including the Aloxa.ai website, mobile application, and WhatsApp chatbot (collectively, the 'Services').")}</p>
            <p data-i18n="terms.agreement">{i18next.t("By accessing or using any part of the Services, you agree to be legally bound by these Terms. If you do not agree with these Terms, please do not use the Services.")}</p>

            <h3 data-i18n="terms.sections.scope.title">{i18next.t("1. Scope of Services")}</h3>
            <p data-i18n="terms.sections.scope.intro">{i18next.t("Aloxa.ai provides:")}</p>
            <ul>
                <li data-i18n="terms.sections.scope.items.analysis">{i18next.t("AI-driven hair and scalp analysis using user-submitted photos.")}</li>
                <li data-i18n="terms.sections.scope.items.reports">{i18next.t("Personalized reports regarding hair loss stage and scalp health.")}</li>
                <li data-i18n="terms.sections.scope.items.information">{i18next.t("Information via chatbot on hair care and hair loss.")}</li>
                <li data-i18n="terms.sections.scope.items.tracking">{i18next.t("Progress tracking overtime through mobile application and whatsapp.")}</li>
                <li data-i18n="terms.sections.scope.items.acknowledgement">{i18next.t("Users acknowledge that all reports and interactions via Services are powered by automated Artificial Intelligence systems, and not human review.")}</li>
            </ul>

            <h3 data-i18n="terms.sections.eligibility.title">{i18next.t("2. Eligibility")}</h3>
            <p data-i18n="terms.sections.eligibility.intro">{i18next.t("You must be:")}</p>
            <ul>
                <li data-i18n="terms.sections.eligibility.items.age">{i18next.t("At least 18 years old.")}</li>
                <li data-i18n="terms.sections.eligibility.items.competence">{i18next.t("Fully able and competent to enter into these Terms.")}</li>
                <li data-i18n="terms.sections.eligibility.items.minor">{i18next.t("We do not knowingly allow individuals under 18 years of age to access or use the Services. If we become aware that data from a minor has been collected, we will delete it immediately.")}</li>
            </ul>
            <p data-i18n="terms.sections.eligibility.confirmation">{i18next.t("By using the Services, you confirm you meet these eligibility requirements.")}</p>

            <h3 data-i18n="terms.sections.photoSubmission.title">{i18next.t("3. User Photo Submission & AI Analysis")}</h3>
            <p data-i18n="terms.sections.photoSubmission.content1">{i18next.t("To generate a hair loss and scalp analysis, users may be asked to upload four photographs: front, left, right, and top views of the head.")}</p>
            <p data-i18n="terms.sections.photoSubmission.content2">{i18next.t("By uploading photos, you:")}</p>
            <ul>
                <li data-i18n="terms.sections.photoSubmission.items.license">{i18next.t("Grant Centa Biotech a non-exclusive, limited, revocable, royalty-free license to use, process, and store your uploaded photos strictly for (a) providing personalized scalp assessments, (b) improving AI model accuracy via de-identified data, and (c) fulfilling legal obligations.")}</li>
                <li data-i18n="terms.sections.photoSubmission.items.masking">{i18next.t("Acknowledge that faces are automatically masked to ensure anonymity.")}</li>
                <li data-i18n="terms.sections.photoSubmission.items.processing">{i18next.t("Photos are processes using automated face-masking technology prior to any analysis to prevent identification. De-identified photos do not knowingly contain any personally identifiable information as defined under Article 4 of the GDPR.")}</li>
                <li data-i18n="terms.sections.photoSubmission.items.training">{i18next.t("Consent that de-identified photos may be used in training AI models to improve accuracy and performance, without linking back to your identity.")}</li>
                <li data-i18n="terms.sections.photoSubmission.items.consent">{i18next.t("You may provide or withdraw consent for optional use of your de-identified images in research or AI training datasets separately. Refusal to provide such consent will not affect access to the primary service.")}</li>
            </ul>
                
            <h3 data-i18n="terms.sections.account.title">{i18next.t("4. Account Registration")}</h3>
            <p data-i18n="terms.sections.account.intro">{i18next.t("Certain features (e.g., progress tracking) may require account creation. You agree to:")}</p>
            <ul>
                <li data-i18n="terms.sections.account.items.accuracy">{i18next.t("Provide accurate information.")}</li>
                <li data-i18n="terms.sections.account.items.confidentiality">{i18next.t("Maintain confidentiality of login credentials.")}</li>
                <li data-i18n="terms.sections.account.items.security">{i18next.t("Notify us immediately in case of unauthorized access.")}</li>
                <li data-i18n="terms.sections.account.items.ownership">{i18next.t("Ensure that your uploaded photographs are your own and do not depict third parties.")}</li>
            </ul>

            <h3 data-i18n="terms.sections.acceptableUse.title">{i18next.t("5. Acceptable Use Policy")}</h3>
            <p data-i18n="terms.sections.acceptableUse.intro">{i18next.t("You agree not to:")}</p>
            <ul>
                <li data-i18n="terms.sections.acceptableUse.items.lawful">{i18next.t("Use the Services for unlawful, commercial, or malicious purposes.")}</li>
                <li data-i18n="terms.sections.acceptableUse.items.thirdParty">{i18next.t("Upload images that are not yours or violate third-party privacy.")}</li>
                <li data-i18n="terms.sections.acceptableUse.items.interfere">{i18next.t("Interfere with the Services' functionality or security.")}</li>
                <li data-i18n="terms.sections.acceptableUse.items.reverse">{i18next.t("Attempt to reverse engineer or misuse our AI systems.")}</li>
                <li data-i18n="terms.sections.acceptableUse.items.others">{i18next.t("Do not use the service to submit photos of other individuals without lawful basis or their explicit consent.")}</li>
            </ul>

            <h3 data-i18n="terms.sections.privacy.title">{i18next.t("6. Privacy and Data Protection")}</h3>
            <p data-i18n="terms.sections.privacy.content1">{i18next.t("Your use of the Services is subject to our Privacy Policy (link placeholder). This policy outlines the categories of personal data collected (including photos), legal bases under Article 6 and 9 of the GDPR, retention periods, data subject rights, cross-border transfers, and security measures.")}</p>
            <p data-i18n="terms.sections.privacy.content2">{i18next.t("It is to be noted that Privacy Policy herein explains:")}</p>
            <ul>
                <li data-i18n="terms.sections.privacy.items.consent">{i18next.t("Your photographs are processed under explicit consent.")}</li>
                <li data-i18n="terms.sections.privacy.items.separate">{i18next.t("Your consent is obtained separately for Services and optional AI training.")}</li>
                <li data-i18n="terms.sections.privacy.items.research">{i18next.t("Anonymised data may be used for research or performance optimisation.")}</li>
                <li data-i18n="terms.sections.privacy.items.data">{i18next.t("What personal and health-related data we collect.")}</li>
                <li data-i18n="terms.sections.privacy.items.usage">{i18next.t("How we use, store, and secure your data.")}</li>
                <li data-i18n="terms.sections.privacy.items.anonymization">{i18next.t("How we anonymize your images for training purposes.")}</li>
            </ul>
            <p data-i18n="terms.sections.privacy.compliance">{i18next.t("We adhere to GDPR and other relevant data protection laws. Your consent is required for any personally identifiable data use beyond what is needed to provide the service. Agencia Española de Protección de Datos is our Supervisory Authority.")}</p>

            <h3 data-i18n="terms.sections.disclaimer.title">{i18next.t("7. AI Limitations & Medical Disclaimer")}</h3>
            <ul>
                <li data-i18n="terms.sections.disclaimer.items.medical">{i18next.t("The AI-generated reports are informational tools, not a substitute for professional medical advice, diagnosis, or treatment.")}</li>
                <li data-i18n="terms.sections.disclaimer.items.accuracy">{i18next.t("We do not guarantee clinical accuracy or efficacy of any suggested action based on AI analysis.")}</li>
                <li data-i18n="terms.sections.disclaimer.items.device">{i18next.t("This platform is not a medical device and is not registered under the EU Medical Device Regulation (EU MDR 2017/745). Users must not rely solely on AI outputs for clinical decisions.")}</li>
            </ul>
            <p data-i18n="terms.sections.disclaimer.advice">{i18next.t("Please consult a healthcare provider before making any medical decisions.")}</p>

            <h3 data-i18n="terms.sections.dataRetention.title">{i18next.t("8. Data Retention and Deletion")}</h3>
            <ul>
                <li data-i18n="terms.sections.dataRetention.items.deletion">{i18next.t("You can request deletion of your account and personal data by contacting us at contact@aloxa.ai or use the options provided in the whatsapp / mobile app")}</li>
                <li data-i18n="terms.sections.dataRetention.items.storage">{i18next.t("User account data and uploaded photos are stored for a period of 12 months from last activity, unless deleted earlier upon request as provided hereinabove.")}</li>
                <li data-i18n="terms.sections.dataRetention.items.datasets">{i18next.t("AI training datasets retains only anonymized data with irreversible masking. These may be retained indefinitely for performance improvement, in line with GDPR Recital 26 and Article 89.")}</li>
            </ul>

            <h3 data-i18n="terms.sections.ip.title">{i18next.t("9. Intellectual Property")}</h3>
            <p data-i18n="terms.sections.ip.content">{i18next.t("All intellectual property related to the platform, including AI models, branding, content, and code, is the exclusive property of Centa Biotech. You may not copy, use, or distribute any materials without prior written consent. This includes all proprietary AI models developed by Centa Biotech and any derivative works from de-identified datasets.")}</p>

            <h3 data-i18n="terms.sections.thirdParty.title">{i18next.t("10. Third-Party Platforms")}</h3>
            <p data-i18n="terms.sections.thirdParty.content">{i18next.t("Our WhatsApp chatbot uses WhatsApp's API. By using it, you also agree to WhatsApp's terms and policies. We are not responsible for external platform issues or limitations. WhatsApp's servers may process user messages and metadata outside the EU. We only ensure GDPR compliant transfer mechanisms (e.g., Standard Contractual Clauses) are in place fpr such third-party platforms.")}</p>

            <h3 data-i18n="terms.sections.liability.title">{i18next.t("11. Limitation of Liability")}</h3>
            <p data-i18n="terms.sections.liability.intro">{i18next.t("To the fullest extent permitted by applicable law, and without prejudice your fundamental rights under the GDPR and EU consumer law:")}</p>
            <ul>
                <li data-i18n="terms.sections.liability.items.damages">{i18next.t("We are not liable for any indirect, incidental, or consequential damages.")}</li>
                <li data-i18n="terms.sections.liability.items.warranty">{i18next.t("We do not warrant uninterrupted access, error-free operation, or complete accuracy of AI outputs.")}</li>
            </ul>

            <h3 data-i18n="terms.sections.modifications.title">{i18next.t("12. Modifications to Terms")}</h3>
            <p data-i18n="terms.sections.modifications.content">{i18next.t("Centa Biotech reserves the right to modify these Terms at any time. We will notify users through the website or app. Significant changes to Terms or Privacy Policy will be notified via email or in-app alerts. Continued use after updates indicates acceptance of the new Terms. Renewed consent will be sought where legally required (e.g., changes to processing purposes.)")}</p>

            <h3 data-i18n="terms.sections.governingLaw.title">{i18next.t("13. Governing Law and Jurisdiction")}</h3>
            <p data-i18n="terms.sections.governingLaw.content">{i18next.t("These Terms shall be governed by and construed in accordance with the laws of Spain. Any disputes shall be subject to the exclusive jurisdiction of the courts of Malaga, Spain.")}</p>

            <h3 data-i18n="terms.sections.contact.title">{i18next.t("14. Contact Information")}</h3>
            <p data-i18n="terms.sections.contact.intro">{i18next.t("For any questions, feedback, or data access requests:")}</p>
            <p data-i18n="terms.sections.contact.company">{i18next.t("Centa Biotech SL")}</p>
            <p data-i18n="terms.sections.contact.address">{i18next.t("Alameda Principal 11, 29001 Malaga, Spain")}</p>
            <p data-i18n="terms.sections.contact.email">{i18next.t("Email: contact@aloxa.ai")}</p>

            <h3 data-i18n="terms.sections.transparency.title">{i18next.t("15. Services Transparency and Oversight")}</h3>
            <p data-i18n="terms.sections.transparency.content">{i18next.t("Our services rely on automated Artificial Intelligence systems. While our AI models are trained using anonymised data, they may generate probabilistic outputs based on image analysis. These outputs are not final or conclusive. We encourage human review of all results and disclaim liability for decisions taken solely on the basis of AI recommendation.")}</p>

            <h3 data-i18n="terms.sections.final.title">{i18next.t("Final Statement")}</h3>
            <p data-i18n="terms.sections.final.content">{i18next.t("By using Aloxa.ai Services, you confirm that you have read, understood, and agreed to these Terms.")}</p>
            </div>
        </div>
    </div>
    ),
    privacypolicy: (
      <div className="container privacy-main-div">
        <h1 className="privacy-title" data-i18n="privacy.title">
          {t("Privacy Policy")}
        </h1>
        <div>
          <div>
            <h3>{t("Effective Date: January 1, 2025")}</h3>
            <p data-i18n="privacy.intro1">
              {t(
                "This Privacy Policy complies with Regulation (EU) 2016/679 (GDPR) and includes AI transparency standards under Regulation (EU) 2024/1689 (AI Act)."
              )}
            </p>
            <p data-i18n="privacy.intro2">
              {t(
                "Centa Biotech SL ('Centa Biotech', 'we', 'us', or 'our') is committed to protecting your privacy. This Privacy Policy outlines how we collect, use, disclose, and safeguard your information when you visit and use our services through Aloxa.ai, including our website, mobile application, and WhatsApp chatbot (collectively referred to as the 'Services'). This policy is designed in accordance with the General Data Protection Regulation (GDPR)."
              )}
            </p>

            <h3 data-i18n="privacy.sections.dataController.title">
              {t("1. Data Controller")}
            </h3>
            <p data-i18n="privacy.sections.dataController.content1">
              {t(
                "Centa Biotech SL is the data controller for all personal data collected via Aloxa.ai."
              )}
            </p>
            <p data-i18n="privacy.sections.dataController.address">
              {t("Address: Alameda Principal 11, 29001 Malaga, Spain")}
            </p>
            <p data-i18n="privacy.sections.dataController.email">
              {t("Email: contact@aloxa.ai")}
            </p>
            <p data-i18n="privacy.sections.dataController.dpo">
              {t(
                "If you have any questions regarding this policy, you may contact our appointed DPO at dpo@aloxa.ai"
              )}
            </p>

            <h3 data-i18n="privacy.sections.dataCollected.title">
              {t("2. Types of Data Collected")}
            </h3>
            <p data-i18n="privacy.sections.dataCollected.intro">
              {t("We may collect the following types of data:")}
            </p>
            <ul>
              <li data-i18n="privacy.sections.dataCollected.items.identity">
                {t(
                  "Identity Data: Gender, age (self-declared to confirm eligibility)"
                )}
              </li>
              <li data-i18n="privacy.sections.dataCollected.items.contact">
                {t("Contact Data: Phone number")}
              </li>
              <li data-i18n="privacy.sections.dataCollected.items.image">
                {t(
                  "Image Data: photographs of your head (front, back, top, and sides) for AI analysis. Since biometric in nature under Article 9 of GDPR, though processed in de-identified format via facial masking."
                )}
              </li>
              <li data-i18n="privacy.sections.dataCollected.items.technical">
                {t(
                  "Technical Data: IP address, device type, operating system, and browsing behavior."
                )}
              </li>
              <li data-i18n="privacy.sections.dataCollected.items.communication">
                {t(
                  "Communication Data: interactions through the WhatsApp chatbot and app feedback."
                )}
              </li>
              <li data-i18n="privacy.sections.dataCollected.items.consent">
                {t(
                  "Consent Data: Timestamped records of consent for data processing, optional research participation, and AI training."
                )}
              </li>
            </ul>

            <h3 data-i18n="privacy.sections.legalBasis.title">
              {t("3. Legal Basis for Processing")}
            </h3>
            <p data-i18n="privacy.sections.legalBasis.intro">
              {t(
                "We process personal data based on the following legal grounds under Articles 6 and 9 of the GDPR:"
              )}
            </p>
            <ul>
              <li data-i18n="privacy.sections.legalBasis.items.consent">
                {t(
                  "Consent (Article 6(1)(a) and 9 (2)(a)): You provide explicit, informed consent for the collection and analysis of photographs and for optional use in anonymised AI training."
                )}
              </li>
              <li data-i18n="privacy.sections.legalBasis.items.legitimate">
                {t(
                  "Legitimate Interests (Article 6(1)(f)): We may process anonymised and aggregated data to improve model accuracy and user experience."
                )}
              </li>
              <li data-i18n="privacy.sections.legalBasis.items.legal">
                {t(
                  "Legal Obligation(Article 6(1)(c)): In certain cases, we may be required to retain or disclose data to comply with applicable laws and regulations."
                )}
              </li>
            </ul>

            <h3 data-i18n="privacy.sections.purposes.title">
              {t("4. Purposes of Processing")}
            </h3>
            <p data-i18n="privacy.sections.purposes.intro">
              {t("We use the collected data for the following purposes:")}
            </p>
            <ul>
              <li data-i18n="privacy.sections.purposes.items.analysis">
                {t(
                  "To provide personalized AI-driven hair and scalp analysis."
                )}
              </li>
              <li data-i18n="privacy.sections.purposes.items.tracking">
                {t("To track user progress over time.")}
              </li>
              <li data-i18n="privacy.sections.purposes.items.support">
                {t("To respond to user inquiries and provide support.")}
              </li>
              <li data-i18n="privacy.sections.purposes.items.improvement">
                {t(
                  "To develop and improve our AI models using anonymized data."
                )}
              </li>
              <li data-i18n="privacy.sections.purposes.items.compliance">
                {t("To comply with legal and regulatory obligations.")}
              </li>
              <li data-i18n="privacy.sections.purposes.items.limitations">
                {t(
                  "We do not process data for medical diagnosis, emotional profiling, biometric categorisation under the EU AI Act, or automated decision making with legal/ equivalent effect."
                )}
              </li>
            </ul>

            <h3 data-i18n="privacy.sections.anonymization.title">
              {t("5. Facial Masking and Anonymization")}
            </h3>
            <p data-i18n="privacy.sections.anonymization.content1">
              {t(
                "All uploaded images undergo irreversible facial masking using AI-powered anonymization tools prior to any processing. No original photos are used in model training without this de-identification. Metadata is removed, and stored image vectors cannot be linked back to the individual users."
              )}
            </p>
            <p data-i18n="privacy.sections.anonymization.content2">
              {t(
                "We conduct periodic audits to verify the irreversibility of anonymisation and avoid biometric identification."
              )}
            </p>

            <h3 data-i18n="privacy.sections.dataSharing.title">
              {t("6. Data Sharing and Disclosure")}
            </h3>
            <p data-i18n="privacy.sections.dataSharing.intro">
              {t(
                "We do not sell or rent your personal data. We may share your data with:"
              )}
            </p>
            <ul>
              <li data-i18n="privacy.sections.dataSharing.items.processors">
                {t(
                  "Trusted sub-processors or service providers who are contractually bound by GDPR compliant Data Processing Agreements, processing data on our behalf under strict confidentiality."
                )}
              </li>
              <li data-i18n="privacy.sections.dataSharing.items.authorities">
                {t(
                  "Legal authorities, if required by law or to protect legal rights."
                )}
              </li>
              <li data-i18n="privacy.sections.dataSharing.items.research">
                {t(
                  "Research partners in anonymized and aggregated format only."
                )}
              </li>
              <li data-i18n="privacy.sections.dataSharing.items.transfers">
                {t(
                  "Where there is possibility of third-country transfers are involved (e.g. WhatsApp), we only ensure adequate safeguards as applicable under GDPR (especially Chapter V), including Standard Contractual Clauses."
                )}
              </li>
            </ul>

            <h3 data-i18n="privacy.sections.internationalTransfers.title">
              {t("7. International Data Transfers")}
            </h3>
            <p data-i18n="privacy.sections.internationalTransfers.content">
              {t(
                "Your personal data may be transferred outside the EU/ EEA only where (a) an adequacy decision exists; or (b) appropriate safeguards such as Standard Contractual Clauses (SCCs) or Binding Corporate Rules (BCRs) are implemented, and enforceable user rights and legal remedies are available."
              )}
            </p>

            <h3 data-i18n="privacy.sections.dataRetention.title">
              {t("8. Data Retention")}
            </h3>
            <p data-i18n="privacy.sections.dataRetention.intro">
              {t(
                "We retain personal data only as long as necessary to fulfill the purposes stated in this policy or as required by law."
              )}
            </p>
            <ul>
              <li data-i18n="privacy.sections.dataRetention.items.account">
                {t(
                  "User account and report data: retained for up to 12 months from last interaction or until user requests deletion, whichever is earlier."
                )}
              </li>
              <li data-i18n="privacy.sections.dataRetention.items.consent">
                {t(
                  "Consent records: Retained for 5 (five) years as proof of compliance."
                )}
              </li>
              <li data-i18n="privacy.sections.dataRetention.items.anonymized">
                {t(
                  "Anonymized image data: may be retained indefinitely for legitimate interest in research and performance optimisation, per GDPR Recitals 26 and Article 89."
                )}
              </li>
            </ul>

            <h3 data-i18n="privacy.sections.yourRights.title">
              {t("9. Your Rights under GDPR")}
            </h3>
            <p data-i18n="privacy.sections.yourRights.intro">
              {t("You have the right to:")}
            </p>
            <ul>
              <li data-i18n="privacy.sections.yourRights.items.access">
                {t("Access your personal data.")}
              </li>
              <li data-i18n="privacy.sections.yourRights.items.rectify">
                {t("Rectify inaccurate or incomplete data.")}
              </li>
              <li data-i18n="privacy.sections.yourRights.items.erase">
                {t("Erase your data ('right to be forgotten').")}
              </li>
              <li data-i18n="privacy.sections.yourRights.items.restrict">
                {t("Restrict or object to processing.")}
              </li>
              <li data-i18n="privacy.sections.yourRights.items.withdraw">
                {t("Withdraw consent at any time.")}
              </li>
              <li data-i18n="privacy.sections.yourRights.items.complain">
                {t("Lodge a complaint with a supervisory authority.")}
              </li>
              <li data-i18n="privacy.sections.yourRights.items.object">
                {t("Object to processing based on legitimate interest.")}
              </li>
            </ul>
            <p data-i18n="privacy.sections.yourRights.contact">
              {t(
                "You can exercise your rights by emailing contact@aloxa.ai. We will respond within 30 (Thirty) days as required under Article 12 of the GDPR."
              )}
            </p>

            <h3 data-i18n="privacy.sections.dataSecurity.title">
              {t("10. Data Security")}
            </h3>
            <p data-i18n="privacy.sections.dataSecurity.intro">
              {t(
                "We implement technical and organizational measures to protect your data including:"
              )}
            </p>
            <ul>
              <li data-i18n="privacy.sections.dataSecurity.items.encryption">
                {t("End-to-end encryption during image upload.")}
              </li>
              <li data-i18n="privacy.sections.dataSecurity.items.pseudonymization">
                {t(
                  "Pseudonymisation of identifiable data prior to AI model ingestion."
                )}
              </li>
              <li data-i18n="privacy.sections.dataSecurity.items.storage">
                {t("Secure data storage with access controls.")}
              </li>
              <li data-i18n="privacy.sections.dataSecurity.items.audits">
                {t("Regular system audits and vulnerability assessments.")}
              </li>
              <li data-i18n="privacy.sections.dataSecurity.items.access">
                {t(
                  "Limited access protocols and audit trails for sensitive processing environments."
                )}
              </li>
            </ul>

            <h3 data-i18n="privacy.sections.children.title">
              {t("11. Children's Privacy")}
            </h3>
            <p data-i18n="privacy.sections.children.content">
              {t(
                "Our services are not intended for individuals under the age of 18. We do not knowingly collect data from minors. If you believe we have inadvertently collected data from a child, please contact us immediately so we can delete it."
              )}
            </p>

            <h3 data-i18n="privacy.sections.changes.title">
              {t("12. Changes to this Privacy Policy")}
            </h3>
            <p data-i18n="privacy.sections.changes.content">
              {t(
                "We may update this Privacy Policy from time to time. Any changes will be communicated via our website or app. Continued use of the services indicates acceptance of the updated policy. Where changes affect the purpose of data processing or involve new legal bases, renewed consent will be sought in accordance with Article 13(3) of the GDPR."
              )}
            </p>

            <h3 data-i18n="privacy.sections.aiSystem.title">
              {t("13. Automated AI System Use")}
            </h3>
            <p data-i18n="privacy.sections.aiSystem.content">
              {t(
                "Aloxa.ai uses AI-powered systems to generate scalp and hair analysis reports. These systems operate without human intervention. Users are informed that such outputs are purely informational and should not be interpreted as medical guidance. This notice is provided in accordance with Article 52 of the EU AI Act."
              )}
            </p>

            <h3 data-i18n="privacy.sections.contact.title">
              {t("14. Contact Us")}
            </h3>
            <p data-i18n="privacy.sections.contact.intro">
              {t(
                "For any privacy-related concerns or to exercise your data rights, please contact:"
              )}
            </p>
            <p data-i18n="privacy.sections.contact.email">
              {t("Email: contact@aloxa.ai")}
            </p>
            <p data-i18n="privacy.sections.contact.address">
              {t(
                "Address: Centa Biotech SL, Alameda Principal 11, 29001 Malaga, Spain"
              )}
            </p>
          </div>
        </div>
      </div>
    )
  })

  return (
    <>
      <div className='headerTitle'>{keyName && headerTitle[keyName]}</div>
      <div className='htmlContent description'>{keyName && htmlContent[keyName]}</div>
    </>
  )
}

export default HtmlContentMaster